import { Injectable } from "@angular/core";
import { FeedbackResult, IPasswordStrengthMeterService } from 'angular-password-strength-meter';

@Injectable({
    providedIn: 'root'
})

export class CustomPSMService extends IPasswordStrengthMeterService{
    scoreAsync(password: string): Promise<number> {
        return Promise.resolve(this.score(password));
    }
    scoreWithFeedbackAsync(password: string): Promise<FeedbackResult> {
        throw new Error("Method not implemented.");
    }
    score(password: any): number {

        return 1;
    }

    scoreWithFeedback(password: any, options?: any): { score: number; feedback: { suggestions: string[]; warning: string; }; } {
        return { score: 1, feedback: { suggestions: [], warning: '' } };
    }
}